/* eslint-disable consistent-return */
import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { cx } from 'emotion';

import Menu from '@ublend-npm/aulaui-next-web/Menu';
import ListItem from '@ublend-npm/aulaui-next-web/ListItem';
import Tooltip from '@ublend-npm/react-tooltip';
import MoreVert from '@material-ui/icons/MoreVert';
import push from '../../../../utils/routing';
import EditContent from '../../common/EditModal/Edit.container';
import UserBanner from '../UserBanner';
import TextButton from '../../common/Buttons/TextButton';
import IconButton from '../../common/Buttons/IconButton';
import ScheduledItemMenu from '../../common/ScheduledItemHeader';
import { isScheduledPost } from '../../../../../core/utils/posts';
import { MAKE_IMPORTANT, NOT_IMPORTANT } from '../../../../constants/texts';

import styles from './style';
import { menu, menuItem, dangerMenuItem } from '../../common/Menu.styled';
import * as TEXT from '../../../../constants/texts';

import { AlertDialog } from '../../common/Dialog';

import { User } from '../types';

const Actions = {
  Open: 'open',
  Edit: 'edit',
  MakeImportant: 'makeImportant',
  Delete: 'delete',
};

const MenuItems = [
  {
    key: Actions.Open,
    getLabel: () => 'Open',
    isVisible: () => true,
    danger: false,
  },
  {
    key: Actions.Edit,
    getLabel: () => 'Edit',
    isVisible: ({ isAuthor, isReadOnlyUser }) => !isReadOnlyUser && isAuthor,
    danger: false,
  },
  {
    key: Actions.MakeImportant,
    getLabel: ({ post }) => (!post.important ? MAKE_IMPORTANT : NOT_IMPORTANT),
    isVisible: ({ isEducator, post }) =>
      isEducator && (!post.scheduledFor || !!post.publishedAt),
    danger: false,
  },
  {
    key: Actions.Delete,
    getLabel: () => 'Delete',
    isVisible: ({ isAuthor, isEducator, isReadOnlyUser }) =>
      !isReadOnlyUser && (isAuthor || isEducator),
    danger: true,
  },
];

@Radium
class PostUserBanner extends React.Component {
  constructor(props) {
    super(props);

    this.moreIconBtnRef = React.createRef();

    this.state = {
      editOpen: false,
      addTagPressed: false,
      deleteDialogOpen: false,
    };

    this.handleImportantPost = this.handleImportantPost.bind(this);
    this.handleSelectMenuItem = this.handleSelectMenuItem.bind(this);
    this.openDeleteDialog = this.openDeleteDialog.bind(this);
    this.closeDeleteDialog = this.closeDeleteDialog.bind(this);
    this.deletePost = this.deletePost.bind(this);
    this.handleAddTag = this.handleAddTag.bind(this);
    this.changeEditOpen = this.changeEditOpen.bind(this);
    this.menuCollapse = this.menuCollapse.bind(this);
    this.openPost = this.openPost.bind(this);
    this.openSchedulePost = this.openSchedulePost.bind(this);
    this.publishPost = this.publishPost.bind(this);

    this.scheduledPostItems = [
      {
        label: 'Change scheduled time',
        action: this.openSchedulePost,
      },
      {
        label: 'Publish now',
        action: this.publishPost,
      },
    ];
  }

  handleImportantPost() {
    const {
      post: { objectId, important },
      handleSetImportant,
      handleUnsetImportant,
    } = this.props;

    if (important) {
      handleUnsetImportant(objectId);
    } else {
      handleSetImportant(objectId);
    }
  }

  handleSelectMenuItem({ item }) {
    switch (item) {
      case Actions.Open:
        this.openPost();
        break;
      case Actions.Edit:
        this.changeEditOpen();
        break;
      case Actions.MakeImportant:
        this.handleImportantPost();
        break;
      case Actions.Delete:
        this.openDeleteDialog();
        break;
      default:
        break;
    }
  }

  openDeleteDialog() {
    this.setState({ deleteDialogOpen: true });
  }

  closeDeleteDialog() {
    this.setState({ deleteDialogOpen: false });
  }

  openPost() {
    const {
      post: { objectId, classRoom },
    } = this.props;

    push(`/dashboard/${classRoom}/community/post/${objectId}`);
  }

  deletePost() {
    const {
      post: { objectId },
      handleDelete,
    } = this.props;

    handleDelete(objectId);
    this.closeDeleteDialog();
  }

  handleAddTag() {
    const { addTag } = this.props;
    addTag();
    this.setState({ addTagPressed: true });
  }

  changeEditOpen() {
    this.setState({ editOpen: true });
  }

  confirmDeleteDialog() {
    const { deleteDialogOpen } = this.state;
    const { isSaving } = this.props;

    if (deleteDialogOpen === false) return;
    return (
      <AlertDialog
        id="confirm-delete-post"
        title="Delete post"
        message={TEXT.SURE_DELETE_POST}
        open={deleteDialogOpen}
        onClose={this.closeDeleteDialog}
        action={{
          label: 'Delete',
          onClick: this.deletePost,
          danger: true,
          loading: isSaving,
        }}
        secondaryAction={{
          label: 'Cancel',
          onClick: this.closeDeleteDialog,
        }}
      />
    );
  }

  menuCollapse() {
    if (this.moreIconBtnRef && this.moreIconBtnRef.current) {
      this.moreIconBtnRef.current.click();
    }
  }

  openSchedulePost() {
    const { post, handleOpenSchedulePost } = this.props;
    handleOpenSchedulePost(post.objectId);
  }

  publishPost() {
    const { post, handlePublishPost } = this.props;
    handlePublishPost(post.objectId);
  }

  addTagVisible() {
    const { addTag, isAuthor, isEducator, post } = this.props;
    const { addTagPressed } = this.state;
    const postHasTags = !post.tags || post.tags.length > 0;
    const canAddTag = isAuthor || isEducator;
    return !postHasTags && addTag && !addTagPressed && canAddTag;
  }

  render() {
    const { post } = this.props;
    const { editOpen } = this.state;
    const ariaLabelId = `post-${post.objectId}`;
    return (
      <div id={ariaLabelId} style={styles.container}>
        {this.confirmDeleteDialog()}
        {/* Left container : Avatar + Username */}
        {!isScheduledPost(post) ? (
          <UserBanner
            user={post.user}
            time={post.scheduledFor || post.createdAt}
          />
        ) : (
          <ScheduledItemMenu
            scheduledFor={post.scheduledFor}
            items={this.scheduledPostItems}
          />
        )}
        {/* Right container : IconMenu */}
        <div style={styles.rightContainer}>
          <Menu
            menuListComponent="ul"
            classes={{ menu }}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            renderTarget={({ handleTargetClick, isOpen }) => (
              <Tooltip title="Post options" position="bottom">
                <IconButton
                  icon={MoreVert}
                  size="small"
                  label="Post options"
                  onClick={handleTargetClick}
                  buttonAttributes={{ 'aria-expanded': isOpen }}
                />
              </Tooltip>
            )}
            onSelect={this.handleSelectMenuItem}
            renderChildren={({ getItemProps, highlightedIndex }) =>
              MenuItems.reduce(
                (acc, item, index) =>
                  item.isVisible(this.props)
                    ? [
                        ...acc,
                        <ListItem
                          key={item.key}
                          className={
                            item.danger
                              ? cx(menuItem, dangerMenuItem)
                              : menuItem
                          }
                          primaryText={item.getLabel(this.props)}
                          highlighted={highlightedIndex === index}
                          {...getItemProps({
                            item: item.key,
                            onClick: (e) => e.stopPropagation(),
                            'aria-selected': undefined,
                          })}
                        />,
                      ]
                    : acc,
                []
              )
            }
          />
          {post && (
            <EditContent
              open={editOpen}
              content={post.content}
              itemClass="UBClassRoomPost"
              itemId={post.objectId}
              onClose={() => {
                this.setState({ editOpen: false });
              }}
            />
          )}
          {this.addTagVisible() ? (
            <TextButton
              containerStyles={styles.addTag}
              label="Add tag"
              onClick={this.handleAddTag}
            />
          ) : null}
        </div>
      </div>
    );
  }
}

PostUserBanner.propTypes = {
  post: PropTypes.shape({
    objectId: PropTypes.string,
    important: PropTypes.bool,
    content: PropTypes.string,
    classRoom: PropTypes.string,
    user: User.isRequired,
    scheduledFor: PropTypes.string,
    createdAt: PropTypes.string,
    tags: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  isAuthor: PropTypes.bool.isRequired,
  isEducator: PropTypes.bool.isRequired,
  isReadOnlyUser: PropTypes.bool.isRequired,
  handleDelete: PropTypes.func.isRequired,
  handleSetImportant: PropTypes.func.isRequired,
  handleUnsetImportant: PropTypes.func.isRequired,
  handleOpenSchedulePost: PropTypes.func.isRequired,
  handlePublishPost: PropTypes.func.isRequired,
  addTag: PropTypes.func,
  isSaving: PropTypes.bool,
};

PostUserBanner.defaultProps = {
  isSaving: false,
  addTag: null,
};

export default PostUserBanner;
